/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Action_EmailInputs */

const en_footer_action_email = /** @type {(inputs: Footer_Action_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email builder`)
};

/**
* | output |
* | --- |
* | "Email builder" |
*
* @param {Footer_Action_EmailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_action_email = /** @type {((inputs?: Footer_Action_EmailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Action_EmailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_action_email(inputs)
});